"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsList = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const config_1 = require("@/config/dictionary/config");
const dictionary_1 = require("@/config/dictionary");
const DetailTitle_vue_1 = __importDefault(require("../DetailTitle.vue"));
const overdue_1 = __importDefault(require("../../api/overdue"));
const overdue_2 = require("../../select/overdue");
class ContactsList extends complex_data_1.ComplexList {
}
exports.ContactsList = ContactsList;
const mainData = new ContactsList({
    name: '短信发送记录',
    prop: 'messageList',
    module: {
        pagination: true,
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 8,
                    content: 16
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'businessId',
                    name: '业务ID',
                    originProp: 'businessId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber
                        }
                    }
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'recipientName',
                    name: '接收人',
                    originProp: 'recipientName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'recipientPhone',
                    name: '接收手机号',
                    originProp: 'recipientPhone',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        }
                    }
                },
                {
                    prop: 'smsContent',
                    name: '短信内容',
                    originProp: 'smsContent',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(12)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.messageSendStatus, {
                    prop: 'sendStatus',
                    name: '发送状态',
                    originProp: 'sendStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'smsApiRtn',
                    name: '发送结果',
                    originProp: 'smsApiRtn',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '创建人',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '最后更新人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.messageList.require({
                contractNumber: this.$getExtra('contractNumber'),
                pageNo: this.$getPageData('current'),
                pageSize: this.$getPageData('size')
            }).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = (0, vue_1.defineComponent)({
    name: 'ContactsList',
    components: {
        DetailTitle: DetailTitle_vue_1.default,
        ListView: ListView_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            collapse: this.defaultCollapse,
            mainData: mainData,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: false
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.mainData.$setExtra('contractNumber', this.id);
                    this.mainData.$loadData(true);
                }
            }
        }
    },
    beforeUnmount() {
        mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
